module.exports = __webpack_public_path__ + "static/img/home_cn_partners_m.a484ac3.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/home_cn_partners_m.svg
// module id = EKW7
// module chunks = 0